import React from "react";

import { getDataTestId } from "src/utils";
import { LapsProps } from "./types";
import { useStatusLaps } from "./hooks";

export const Laps = (props: LapsProps) => {
  const { getFinishProps, getLapsProps, getStartProps, values } =
    useStatusLaps(props);

  let content;

  switch (props.game.status) {
    case "started":
      content = (
        <div className={values.styles.title}>
          <span {...getStartProps()}>СТАРТ</span>
        </div>
      );
      break;
    case "play":
      content = (
        <div className={values.styles.lap}>
          <span {...getDataTestId("progress-lap")}>
            ОЖИДАЕМ РЕЗУЛЬТАТ ГОНКИ&nbsp;
          </span>
        </div>
      );
      break;
    case "finished":
      content = (
        <div className={values.styles.title}>
          <span {...getFinishProps()}>ФИНИШ</span>
        </div>
      );
      break;
    default:
      content = <div />;
      break;
  }

  return <div {...getLapsProps()}>{content}</div>;
};

Laps.displayName = "Laps";
